module.exports = __webpack_public_path__ + "static/hoivakotilive_slide_10-f9a06cc05c89db9320ba0b2977f797da.jpg";